import {
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps,
} from '@mui/material';
import { CloseIcon } from 'components/icons';
import VectorIcon from 'components/icons/VectorIcon';
import React, { FC } from 'react';
import { SEARCH_INPUT_NAME } from './constants';

type TextInput = {
  resetInputField: (e: React.MouseEvent<HTMLElement>) => void;
} & TextFieldProps;

const TextInput: FC<TextInput> = ({ resetInputField, ...rest }) => {
  return (
    <TextField
      name={SEARCH_INPUT_NAME}
      type="text"
      placeholder="Search by destination or hotel"
      fullWidth
      autoComplete="off"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <VectorIcon />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            {typeof rest.value === 'string' && rest.value.length > 0 && (
              <IconButton onClick={resetInputField} title="close">
                <CloseIcon />
              </IconButton>
            )}
          </InputAdornment>
        ),
      }}
      sx={{
        '& .MuiInputBase-root': {
          height: '45px',
          fontWeight: 600,
          fontSize: '14px',
        },
        '& input::placeholder': {
          textTransform: 'none',
          color: '#505050',
          fontWeight: 400,
          opacity: 0.9,
        },
      }}
      {...rest}
    />
  );
};

export default TextInput;
